/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import { MenuWrapper } from './menu.style';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  className?: string;
};

/**
 * Export `Menu` component.
 */

export function Menu({ children, className }: Props): JSX.Element {
  return <MenuWrapper className={className}>{children}</MenuWrapper>;
}
